import {
  formatDateWithTime,
  // formatHour,
  gridSizeMdLg12,
  gridSizeMdLg6,
  // useLoaders,
} from "@/shared";
import {
  CustomAutocompleteNoForm,
  CustomTextField,
  CustomTextFieldNoForm,
  // CustomTextFieldNoForm,
  TabTextLabel,
} from "@/shared/components/ui";
import CustomAutocompleteOptimized from "@/shared/components/ui/CustomAutocompleteOptimized";
import { TipoInstalacion } from "@/shared/interfaces";
import { useTypeInstalation } from "@/store/erp/system-settings/type-instalation";

export type OTInstalacionTecnicoFormTabProps = {
  form: any;
  errors: any;
  shrink: boolean;
  viewContratos?: boolean;
  esTraslado?: boolean;
  observacionTraslado?: string;
  observacionRecoordinar?: string;
};

const OTInstalacionTecnicoFormTab: React.FC<
  OTInstalacionTecnicoFormTabProps
> = ({ form, errors, shrink, viewContratos=false, esTraslado=false, observacionTraslado="", observacionRecoordinar="" }) => {
  const typInstalation = useTypeInstalation((s) => s.typInstalation);
  console.log('typInstalation', typInstalation);
  const isLoadingTypeInstalation = useTypeInstalation(
    (s) => s.isLoadingTypeInstalation
  );

  // En un TRASLADO, "Tipo Orden de Trabajo" y "Tipo de Instalación" se muestran
  // como campos de solo lectura fijos en "TRASLADO" (ver render más abajo). Esto
  // evita la carrera del setValue con el reset del form. El backend ya persiste
  // tipo_orden_trabajo='TRASLADO'; tipo_instalacion no aplica al traslado (solo
  // display). No afecta al flujo de instalación (todo guardado por esTraslado).
  const tipoInstalacionOptions = typInstalation || [];
  ///* form ---------------
  // const watchedHora = form.watch('hora_instalacion');



  // useLoaders(
  //   isLoadingTiposIncidenciaPaging || isRefetchingTiposIncidenciaPaging
  // );

  // if (isLoadingTiposIncidenciaPaging)
  //   return null;

  return (
    <>
      {/* ================ Datos generales ================ */}
      <TabTextLabel text="Datos generales" pb={1} pt={1} />
      <>
      {
        viewContratos && (
          <>
            <CustomTextField
              name="user_create_data.razon_social"
              label="Nombre de Vendedor"
              control={form.control}
              defaultValue={form.getValues()?.user_create_data?.razon_social || ""}
              error={errors?.user_create_data?.razon_social}
              helperText={errors?.user_create_data?.razon_social?.message || ""}
              disabled
            />
            <CustomTextField
              name="canal_venta_create_data.nombre"
              label="Canal de Venta"
              control={form.control}
              defaultValue={form.getValues()?.canal_venta_create_data?.nombre || ""}
              error={errors?.canal_venta_create_data?.nombre}
              helperText={errors?.canal_venta_create_data?.nombre?.message || ""}
              disabled
            />
            <CustomTextField
              name="supervisor_data.razon_social"
              label="Supervisor"
              control={form.control}
              defaultValue={form.getValues()?.supervisor_data?.razon_social || ""}
              error={errors?.supervisor_data?.razon_social}
              helperText={errors?.supervisor_data?.razon_social?.message || ""}
              disabled
            />
          </>
        )
      }
        <CustomTextField
          name="flota_data.nombre"
          label="Flota"
          control={form.control}
          defaultValue={form.getValues()?.flota_data?.nombre || ""}
          error={errors?.flota_data?.nombre}
          helperText={errors?.flota_data?.nombre?.message || ""}
          disabled
        />
        {esTraslado ? (
          <CustomTextFieldNoForm
            label="Tipo Orden de Trabajo"
            value="TRASLADO"
            shrink={shrink}
            disabled
          />
        ) : (
          <CustomTextField
            label="Tipo Orden de Trabajo"
            name="tipo_orden_trabajo"
            control={form.control}
            defaultValue={form.getValues().tipo_orden_trabajo || ""}
            error={errors.tipo_orden_trabajo}
            helperText={errors.tipo_orden_trabajo?.message}
            shrink={shrink}
            disabled
          />
        )}

        {esTraslado ? (
          <CustomTextFieldNoForm
            label="Tipo de Instalación"
            value="TRASLADO"
            size={gridSizeMdLg12}
            shrink={shrink}
            disabled
          />
        ) : (
          <CustomAutocompleteOptimized<TipoInstalacion>
            size={gridSizeMdLg12}
            label={"Tipo de Instalación"}
            name="tipo_instalacion"
            // options
            options={tipoInstalacionOptions}
            valueKey="nombre" // name is the fk
            actualValueKey="codigo"
            defaultValue={form.getValues().tipo_instalacion}
            isLoadingData={isLoadingTypeInstalation}
            // validation
            control={form.control}
            error={form.formState.errors.tipo_instalacion as any}
            helperText={form.formState.errors.tipo_instalacion?.message as any}
          />
        )}
      {
        form.watch("tipo_instalacion") === "EMPAQUETADO" &&
          <CustomAutocompleteNoForm
            label="Subtipo de Instalación"
            isLoadingData={false}
            defaultValue={form.getValues().subtipo_instalacion || ""}
            options={
              [
                {
                  nombre:"TIPO 1 (50m a 150m)",
                  codigo:"TIPO 1"
                },
                {
                  nombre:"TIPO 2 (151m a 300m)",
                  codigo:"TIPO 2"
                },
                {
                  nombre:"TIPO 3 (301m a 450m)",
                  codigo:"TIPO 3"
                }
              ]
            }
            valueKey="nombre"
            actualValueKey="codigo"
            onChangeValue={(e) => {
              form.setValue('subtipo_instalacion', e)
            }}
            disabled={true}
          />
      }

        <CustomTextField
          label="Fecha de Instalación"
          name="fecha_instalacion"
          control={form.control}
          defaultValue={form.getValues()?.fecha_instalacion || ""}
          error={errors?.fecha_instalacion}
          helperText={errors?.fecha_instalacion?.message}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        />
        <CustomTextField
          label="Hora de Instalación"
          name="hora_instalacion"
          control={form.control}
          defaultValue={form.getValues()?.hora_instalacion || ""}
          error={errors?.hora_instalacion}
          helperText={errors?.hora_instalacion?.message}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        />
        {/* <CustomTextFieldNoForm
          disabled={true}
          label="Hora de Instalación"
          value={watchedHora ? formatHour(watchedHora) : 'N/A'}
          size={gridSizeMdLg6}
          shrink
        /> */}

        <CustomTextField
          name="planLabel"
          label="Plan Contratado"
          control={form.control}
          defaultValue={form.getValues().planLabel || ""}
          error={errors.planLabel}
          helperText={errors.planLabel?.message || ""}
          size={gridSizeMdLg6}
          disabled
          shrink={shrink}
        />
        <CustomTextField
          name="linea"
          label="Línea Contratada"
          control={form.control}
          defaultValue={form.getValues().prospecto_data?.linea || ''}
          error={errors.prospecto_data?.linea}
          helperText={errors.prospecto_data?.linea?.message?.toString() ?? ''}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        />
        {esTraslado ? (
          <CustomTextFieldNoForm
            label="Tipo de Instalación"
            value="TRASLADO"
            size={gridSizeMdLg6}
            shrink={shrink}
            disabled
          />
        ) : (
          <CustomAutocompleteOptimized<TipoInstalacion>
            size={gridSizeMdLg6}
            label={"Tipo de Instalación"}
            name="tipo_instalacion"
            // options
            options={tipoInstalacionOptions}
            valueKey="nombre" // name is the fk
            actualValueKey="codigo"
            defaultValue={form.getValues().tipo_instalacion}
            isLoadingData={isLoadingTypeInstalation}
            // validation
            control={form.control}
            error={form.formState.errors.tipo_instalacion as any}
            helperText={form.formState.errors.tipo_instalacion?.message as any}
            disabled={true}
          />
        )}
        <CustomTextField
          name="valor_instalacion_total"
          label="Valor de Instalación"
          control={form.control}
          defaultValue={form.getValues().valor_instalacion_total || ""}
          error={errors.valor_instalacion_total}
          helperText={errors.valor_instalacion_total?.message || ""}
          startAdornment={"$"}
          size={gridSizeMdLg6}
          disabled
          shrink={shrink}
        />
      </>


      {/* ================ HORA INICIO/FIN (Activacion/PyL) ================ */}
      <TabTextLabel text="HORA DE INICIO/FINALIZACIÓN" pt={1} pb={1} />
      <CustomTextFieldNoForm
        label="Hora de Inicio"
        value={
          form.getValues()?.fecha_hora_inicio_instalacion?
          formatDateWithTime(form.getValues().fecha_hora_inicio_instalacion) : "No registrado"
        }
        shrink={shrink}
        disabled
        size={gridSizeMdLg6}
      />
      <CustomTextFieldNoForm
        label="Hora de Finalización"
        value={
          form.getValues()?.fecha_hora_fin_instalacion?
          formatDateWithTime(form.getValues().fecha_hora_fin_instalacion) : "No registrado"
        }
        shrink={shrink}
        disabled
        size={gridSizeMdLg6}
      />

      {/* Observaciones que dejó el asesor al agendar el traslado (solo traslados) */}
      {esTraslado && (
        <>
          <TabTextLabel text="OBSERVACIONES PARA EL TÉCNICO" pt={1} pb={1} />
          <CustomTextFieldNoForm
            label="Observaciones del asesor"
            value={observacionTraslado || "Sin observaciones"}
            shrink={shrink}
            disabled
            multiline
            size={gridSizeMdLg12}
          />
          {/* Comentario que dejó el asesor de operaciones al recoordinar el traslado */}
          {observacionRecoordinar ? (
            <CustomTextFieldNoForm
              label="Observaciones Recoordinar"
              value={observacionRecoordinar}
              shrink={shrink}
              disabled
              multiline
              size={gridSizeMdLg12}
            />
          ) : null}
        </>
      )}
    </>
  );
};

export default OTInstalacionTecnicoFormTab;
